<!-- StockTextPopularItem -->
<template>
	<div class="stock_text cursor-pointer" :style="getPercentStyle(pct)" @click="show_kline(stock_code,stock_name)">
		{{rank+"."+stock_name+" "+pct}}
		<span v-if="rank_diff>0" class="badge badge-pill badge-danger">+{{rank_diff}}</span>
		<span v-else-if="rank_diff==0" class="badge badge-pill badge-secondary">=</span>
		<span v-else class="badge badge-pill badge-success">{{rank_diff}}</span>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				theme: 'light'
			};
		},
		props: {
			stock_name: String,
			pct:Number,
			stock_code:String,
			rank:Number,
			rank_diff:Number
		},
		methods: {
			getGradientColor(start_color, end_color, percent) {
				// strip the leading # if it's there
				start_color = start_color.replace(/^\s*#|\s*$/g, '');
				end_color = end_color.replace(/^\s*#|\s*$/g, '');

				// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
				if (start_color.length == 3) {
					start_color = start_color.replace(/(.)/g, '$1$1');
				}

				if (end_color.length == 3) {
					end_color = end_color.replace(/(.)/g, '$1$1');
				}

				// get colors
				function parse(rgb, i) {
					return parseInt(rgb.substr(i, 2), 16)
				}

				let start_r = parse(start_color, 0),
					start_g = parse(start_color, 2),
					start_b = parse(start_color, 4);

				let end_r = parse(end_color, 0),
					end_g = parse(end_color, 2),
					end_b = parse(end_color, 4);

				// calculate new color
				let r = end_r - start_r;
				let g = end_g - start_g;
				let b = end_b - start_b;

				r = ((r * percent) + start_r)
				g = ((g * percent) + start_g)
				b = ((b * percent) + start_b)

				function hex(x) {
					let h = x.toString(16).split('.')[0].toUpperCase()
					return (h.length == 1) ? '0' + h : h
				}

				return '#' + hex(r) + hex(g) + hex(b)
			},

			getPercentColor(pt) {
				const isDark = this.theme === 'dark';
				const baseColor = isDark ? '#1c1c1e' : '#FFFFFF';
				
				if (pt >= 0) {
					if (pt > +10) {
						pt = +10;
					}
					pt = +pt / 10;
					return this.getGradientColor(baseColor, '#FB1023', pt)
				} else {
					if (pt < -10) {
						pt = -10;
					}
					pt = -pt / 10;
					return this.getGradientColor(baseColor, '#278B22', pt)
				}
			},

			getPercentStyle(pt) {
				const isDark = this.theme === 'dark';
				return {
					'background': this.getPercentColor(pt),
					'color': isDark ? '#e5e5e5' : '#000000',
					'border': isDark ? '1px solid #333' : '1px solid #eee'
				}
			},
			show_kline(stock_code,stock_name){
				// console.log("click " +stock_code);
				this.$emit('p_show_kline',stock_code,stock_name)
			}
		},
		mounted() {
			try{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }catch(e){ console.warn('theme read failed', e) }
			this.onThemeChanged = (e)=>{ const theme = e && e.detail && e.detail.theme ? e.detail.theme : (localStorage.getItem('site.theme')||'light'); this.theme = theme; }
			window.addEventListener('site-theme-changed', this.onThemeChanged)
		},
		beforeDestroy() {
			window.removeEventListener('site-theme-changed', this.onThemeChanged)
		}

	}
</script>

<style>
</style>
